<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card p-3">
                <div class="row">
                    <div class="col-12 col-lg-10">
                        <app-breadcrumb
                            subtitle="{{ selectedContienda == 'gubernatura' ? 'Detalle del Distrito' : (labels?.contienda == 'Municipios' ? 'Detalle del Municipio' : (labels?.contienda == 'Juntas' ? 'Detalle por Juntas' : 'Detalle del ' + (labels?.contienda == 'Distritos' ? 'Distrito' : labels?.contienda) )) }}"
                            subtitle_detalle="Votos por Candidatura"
                            [estado]="_obtenerDatosService?.config?.estado"
                            [distrito]="rutas.migas?.distrito"
                            [distrito_param]="rutas.migas?.distrito_clave"
                        ></app-breadcrumb>
                        <div class="texto font-regular">
                            <p *ngIf="selectedContienda == 'gubernatura'">
                                El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas PREP hasta el momento.
                            </p>
                            <p *ngIf="selectedContienda != 'gubernatura'">
                                El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas PREP hasta el momento.
                            </p>

                            <br class="d-block d-xl-none">

                            <p>
                                Por presentación, los decimales de los porcentajes muestran sólo cuatro dígitos. No obstante, al considerar todos los decimales, suman 100%.
                            </p>

                            <br class="d-block d-xl-none">
                            <br class="d-block d-xl-none">
                        </div>
                    </div>
                    <div class="col-2 d-none d-lg-block">
                    </div>
                </div>
                <app-resumen-votacion-mobile
                    [total_num]="resumen?.total?.total"
                    [total_prc]="resumen?.total?.prc"
                ></app-resumen-votacion-mobile>
                <div class="row pb-4">
                    <div class="col">
                        <h4 class="subtitulo-seccion pleca-izquierda my-3">
                            <strong>Votos en Actas Contabilizadas</strong>
                        </h4>
                    </div>
                </div>
                <!-- TARJETAS DE ESCRITORIO -->

                <div class="container-fluid d-none d-md-none d-xl-block">
                    <!-- <div class="row justify-content-center">
                        <div class="col-8 col-sm-4 col-md-3 col-lg-2" *ngFor="let tarjeta of fichas; let indx = index;">
                            <div class="tarjeta card dis-flex flex-col mb-2" [ngClass]="{cardGanador: tarjeta?.winner}"> -->
<!--   siempre comentado                 <img src="assets/res/avatar-persona.svg">-->
                                <!-- <img [src]="'./assets/img/avatar-candidatos/'+tarjeta?.img_perfil">
                                <p class="nombre text-center px-1">
                                    {{ tarjeta?.text }}
                                </p>
                                <div class="distritos w-100 dis-flex py-4 px-1">
                                    <ng-container *ngFor="let img of tarjeta?.imgs">
                                        <img style="height: 30px; border-radius: 0%; width: auto;" [src]="_obtenerDatosService.pathPartidos +img" />
                                    </ng-container>
                                </div>
                                <div class="cuerpo bgGrisTenue dis-flex w-100 p-2">
                                    <div class="w-50">
                                        <p><strong>Votos</strong></p>
                                        <p class="votos" [ngClass]="{textGanador: tarjeta?.winner}" style="padding-right: 8px;">
                                            <strong>
                                                {{ tarjeta?.total }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="w-50 dis-flex flex-col align-e">
                                        <p>Porcentaje</p>
                                        <p>
                                            {{ tarjeta?.porcentaje ? tarjeta?.porcentaje : tarjeta?.prc }}
                                        </p>
                                    </div>
                                </div> -->
                                <!-- siempre comentado <div *ngIf="!tarjeta.seleccionado" (click)="agregarElemento(tarjeta);" class="pie w-100 dis-flex bgMorado txBlanco p-2 cursorPointer">
                                    <p>Seleccionar</p>
                                </div>
                                <div *ngIf="tarjeta.seleccionado" (click)="eliminarElemento(tarjeta);" class="pie w-100 dis-flex bgMorado txBlanco p-2 cursorPointer seleccionado">
                                    <p>Quitar selección</p>
                                </div> -->
                            <!-- </div>
                        </div>
                    </div> -->

                    <div class="col-12 px-0">
                        <div class="table-responsive">
                            <table class="table ft-14" style="border-spacing: 0;border-collapse: separate;">
                                
                                <tbody>
                                    <tr>
                                        <td class="prevent-borders only-bttm-border first-cell">
                                        </td>
                                        <td class="text-center prevent-borders bt-custom only-bttm-border"
                                            *ngFor="let itemPartido of grafica_table; let indx = index;"
                                            [ngClass]="{'grapGanador-init': itemPartido?.winner, 'col-size-ficha': !isObjectEmpty(itemPartido), 'empty-col-size-ficha': isObjectEmpty(itemPartido),'border-init': !isObjectEmpty(itemPartido) && !itemPartido?.winner}">
                                            <div class="img-avatar-size" *ngIf="!isObjectEmpty(itemPartido)">
                                                <img class="avatar" width="100"
                                                    src="./assets/img/avatar-candidatos/{{itemPartido?.img_perfil}}">
                                            </div>
                                        </td>
                                    </tr>
                                    
                                    <tr class="no-bort">
                                        <td class="prevent-borders only-bttm-border first-cell">
                                        </td>
                                        <td class="text-center pdv-0 prevent-borders only-bttm-border"
                                            *ngFor="let itemPartido of grafica_table; let indx = index;"
                                            [ngClass]="{'grapGanador-middle': itemPartido?.winner, 'col-size-ficha': !isObjectEmpty(itemPartido), 'empty-col-size-ficha': isObjectEmpty(itemPartido),'border-middle': !isObjectEmpty(itemPartido) && !itemPartido?.winner}">
                                            <div *ngIf="!isObjectEmpty(itemPartido)">
                                                <span class="nombre-candidato 14px"
                                                    [ngClass]="{'cardGanador-titulo': itemPartido?.winner}">
                                                    {{itemPartido.text}}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="no-bort">
                                        <td class="pdv-0 first-cell" style="border: none;">
                                            <div class="cont-alg">
                                                <span class="px18 font-bold abttm">
                                                    <strong>Votos</strong>
                                                </span>
                                            </div>
                                        </td>
                                        <td class="text-center first-cell" style="border: none;" 
                                            *ngFor="let itemPartido of grafica_table; let indx = index;"
                                            [ngClass]="{'grapGanador-middle': itemPartido?.winner, 'col-size-ficha': !isObjectEmpty(itemPartido), 'empty-col-size-ficha': isObjectEmpty(itemPartido),'border-middle': !isObjectEmpty(itemPartido) && !itemPartido?.winner}">
                                            <ng-container>
                                                <div *ngIf="!isObjectEmpty(itemPartido)">
                                                    <img *ngFor="let img of itemPartido.imgs" class="img-partido force-fit"
                                                        [src]="_obtenerDatosService.pathPartidos +img" />
                                                </div>
                                            </ng-container>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td class="pdv-0 only-bttm-border first-cell">
                                            <span class="em10 font-bold">
                                                <strong>Total</strong>
                                            </span>
                                        </td>
                                        <td class="text-center pdv-0 only-bttm-border" 
                                            *ngFor="let itemPartido of grafica_table; let indx = index;"
                                            [ngClass]="{'grapGanador-middle': itemPartido?.winner, 'no-bort': itemPartido?.winner || !itemPartido?.winner, 'col-size-ficha': !isObjectEmpty(itemPartido), 'empty-col-size-ficha': isObjectEmpty(itemPartido),'border-middle': !isObjectEmpty(itemPartido) && !itemPartido?.winner}">
                                            <ng-container>
                                                <div *ngIf="!isObjectEmpty(itemPartido)">
                                                    <span class="font-bold">
                                                        <strong>{{itemPartido.total}}</strong>
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </td>
                                    </tr>
                                    <tr class="border3-t-rosaINE ">
                                        <td class="bg-gris-3 pdv-2 only-bttm-border first-cell" style="border: none;">
                                            <span class="em10 font-bold">
                                                Porcentaje
                                            </span>
                                        </td>
                                        <!-- <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border"
                                            [ngClass]="{'grapGanador-middle': item?.winner, 'col-size-ficha': !isObjectEmpty(item), 'empty-col-size-ficha': isObjectEmpty(item),'border-middle': !isObjectEmpty(item) && !item?.winner}"> -->
                                        <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border"
                                            [ngClass]="{'grapGanador-end': item?.winner, 'col-size-ficha': !isObjectEmpty(item), 'empty-col-size-ficha': isObjectEmpty(item),'border-end': !isObjectEmpty(item) && !item?.winner}" style="border: none;">
                                            <span class="ft-10" *ngIf="!isObjectEmpty(item)">
                                                {{item.porcentaje}}
                                            </span>
                                        </td>
                                    </tr>
                                    <!-- <tr class="border3-t-rosaINE ">
                                        <td class="bg-gris-3 pdv-2 only-bttm-border first-cell">
                                            <span class="em10">
                                                En Casillas
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border"
                                            [ngClass]="{'grapGanador-middle': item?.winner && (!omitirPreventivos || !omitirAnticipados), 
                                                'grapGanador-end': item?.winner && omitirPreventivos && omitirAnticipados, 
                                                'col-size-ficha': !isObjectEmpty(item), 
                                                'empty-col-size-ficha': isObjectEmpty(item),
                                                'border-middle': !isObjectEmpty(item) && !item?.winner && (!omitirPreventivos || !omitirAnticipados),
                                                'border-end': !isObjectEmpty(item) && !item?.winner && omitirPreventivos && omitirAnticipados
                                            }">
                                            <span class="ft-10" *ngIf="!isObjectEmpty(item)">
                                                {{item.votos_entidad}}
                                            </span>
                                        </td>
                                    </tr> -->
                                    <!-- <tr class="border3-t-rosaINE " *ngIf="!omitirExtranjero">
                                        <td class="bg-gris-3 pdv-2 only-bttm-border">
                                            <span class="px12">
                                                <strong>En el Extranjero</strong>
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border" [ngClass]="{'grapGanador-middle': item?.winner}">
                                            <span class="ft-10" *ngIf="!isObjectEmpty(item)">
                                                {{item.votos_extranjero}}
                                            </span>
                                        </td>
                                    </tr> -->
                                    <!-- <tr class="border3-t-rosaINE " *ngIf="!omitirAnticipados">
                                        <td class="bg-gris-3 pdv-2 only-bttm-border first-cell">
                                            <span class="em10">
                                                Anticipados
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border"
                                            [ngClass]="{'grapGanador-middle': item?.winner && !omitirPreventivos, 
                                                'grapGanador-end': item?.winner && omitirPreventivos, 
                                                'col-size-ficha': !isObjectEmpty(item), 
                                                'empty-col-size-ficha': isObjectEmpty(item),
                                                'border-middle': !isObjectEmpty(item) && !item?.winner,
                                                'border-end': !isObjectEmpty(item) && !item?.winner && omitirPreventivos
                                            }">
                                            <span class="ft-10" *ngIf="!isObjectEmpty(item)">
                                                {{item.votos_anticipados ? item.votos_anticipados : '0'}}
                                            </span>
                                        </td>
                                    </tr>

                                    <tr class="border3-t-rosaINE " *ngIf="!omitirPreventivos">
                                        <td class="bg-gris-3 pdv-2 first-cell" style="border: none;">
                                            <span class="em10">
                                                En Prisión Preventiva
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table; let indx = index;"
                                            class="text-center bg-rosa2 pdv-2 only-bttm-border" 
                                            [ngClass]="{'grapGanador-end': item?.winner, 'col-size-ficha': !isObjectEmpty(item), 'empty-col-size-ficha': isObjectEmpty(item),'border-end': !isObjectEmpty(item) && !item?.winner}" style="border: none;">
                                            <span class="ft-10" *ngIf="!isObjectEmpty(item)">
                                                {{item.votos_preventivos ? item.votos_preventivos : '0'}}
                                            </span>
                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <!-- TARJETAS MOVIL -->
                <movil-listado-content
                    [selectedItemFunc]="selectedItemFun"
                    [diselectedItemFunc]="diselectedItemFun"
                    [(infoList)]="fichas"
                    [tipoTarjeta]="4"></movil-listado-content>
                <!--********************************************************************************************************************-->

                <div class="container-fluid">
                    <div class="row dis-flex">
                        <div class="col-md-12">
                            <div class="row dis-flex justify-s">

                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="container-fluid py-4 d-none d-xl-block">
                    <div class="row">
                        <div class="col-md-12 dis-flex justify-e">
                            <i class="fas fa-info-circle mr-2" aria-hidden="true"></i>
                            <p class="texto">
                                Da clic en <strong>Seleccionar</strong> para visualizar el detalle de la votación. Puedes seleccionar hasta tres opciones.
                            </p>
                            <button [disabled]="comparativaService?.arregloElementos.length < 1" (click)="comparativaService.reiniciarModal()" class="boton-detalle btn bgMorado txBlanco btn-sm texto ml-2 px-4 cursorPointer" data-toggle="modal" data-target="#modalComparativa">
                                Ver detalle
                            </button>
                        </div>
                    </div>
                </div> -->

                <!-- <p class="p-3" style="font-size: 1.4em; text-align: justify;">Por presentación, los decimales de los porcentajes muestran sólo cuatro dígitos. No obstante, al considerar todos los decimales, suman 100%.</p> -->

				<app-resumen-votacion
                    [hide_legend]="true"
					[acumulados_num]="resumen?.acumulados?.total"
					[acumulados_prc]="resumen?.acumulados?.prc"
					[noregistradas_num]="resumen?.no_registradas?.total"
					[noregistradas_prc]="resumen?.no_registradas?.prc"
					[nulos_num]="resumen?.nulos?.total"
					[nulos_prc]="resumen?.nulos?.prc"
					[total_num]="resumen?.total?.total"
					[total_prc]="resumen?.total?.prc"
                    [hide_prc]="false"
                    [use_nulos_tooltip]="false"
				></app-resumen-votacion>

                <!-- <div class="container-fluid py-4 d-block d-xl-none">
                    <div class="row">
                        <div class="col-md-12 dis-flex justify-e">
                            <button [disabled]="comparativaService?.arregloElementos.length < 1" (click)="comparativaService.reiniciarModal()" class="boton-detalle btn bgMorado txBlanco btn-sm texto ml-2 px-4 cursorPointer" data-toggle="modal" data-target="#modalComparativa">
                                Ver detalle
                            </button>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
    </div>
</div>
<app-distribucion-votos [contienda]="labels?.contienda_s"></app-distribucion-votos>
<app-votos-extra 
    [distrito_param]="rutas.migas?.distrito_clave"
    [omitirAnticipados]="omitirAnticipados"
    [omitirPreventivos]="omitirPreventivos"
    [omitirAnticipadosDem]="omitirAnticipadosDem"
    [omitirPreventivosDem]="omitirPreventivosDem"
></app-votos-extra>
<app-estadistica-nacional
    [tipo_estadistica]="rutas.migas?.distrito"
    [use_custom_data]="true"
    [custom_data]="datosEstadistica"
></app-estadistica-nacional>
